import { DatePipe } from '@angular/common';

// Class aceDates
// Transform Dates
// 1) SQL Server DateTimeOFfset to local datetime
export class aceDates {
  constructor() {}

  //converts a sql server DateTimeOffset to a loczlized datetime in typescript Date Object
  // Notes:
  // 1) This format is how a null/undefined date gets returned from SQL Server: 0001-01-01T00:00:00+00:00
  // 2) This is the format of a non null datetime date from SQL Server. 2024-10-31T20:58:11-07:00  :: -07.00 is the time minus GMT.
  gmtOffsetToLocalDate(sourceDate: Date): Date {
    let datePipe: DatePipe = new DatePipe('en-US');
    let localizedDate: Date;

    try {
      if (sourceDate != undefined && sourceDate != null) {
        //Check to see if the date isn't undefined.  The format below will be undefined/null
        if (sourceDate.toString() == '0001-01-01T00:00:00+00:00') {
          localizedDate = undefined;
        } else {
          const timeZoneOffset: number = +sourceDate.toString().substring(19, 22); // Get the timezone offset

          const nativeDate: Date = new Date(sourceDate.toString().substring(0, 19));

          localizedDate = new Date(nativeDate.setTime(nativeDate.getTime() + timeZoneOffset * 60 * 60 * 1000));
        }
      }
    } catch (err) {
      localizedDate = undefined;
    }

    return localizedDate;
  }

  getDateOnly(date: Date): Date {
    const _date = new Date(date);
    return new Date(_date.getFullYear(), _date.getMonth(), _date.getDate());
  }

  /**
   * Adds time to a date
   * 20240712 :: Ken Moss
   * Code from stackoverflow search, modified and vetted
   * @param date  source Date
   * @param interval  One of the following: year, quarter, month, week, day, hour, minute, second
   * @param units  Number of units of the given interval to add.
   */
  dateAdd(date, interval, units): Date {
    if (!(date instanceof Date)) return undefined;
    var ret = new Date(date); //don't change original date
    var checkRollover = function () {
      if (ret.getDate() != date.getDate()) ret.setDate(0);
    };
    switch (String(interval).toLowerCase()) {
      case 'year':
        ret.setFullYear(ret.getFullYear() + units);
        checkRollover();
        break;
      case 'quarter':
        ret.setMonth(ret.getMonth() + 3 * units);
        checkRollover();
        break;
      case 'month':
        ret.setMonth(ret.getMonth() + units);
        checkRollover();
        break;
      case 'week':
        ret.setDate(ret.getDate() + 7 * units);
        break;
      case 'day':
        ret.setDate(ret.getDate() + units);
        break;
      case 'hour':
        ret.setTime(ret.getTime() + units * 3600000);
        break;
      case 'minute':
        ret.setTime(ret.getTime() + units * 60000);
        break;
      case 'second':
        ret.setTime(ret.getTime() + units * 1000);
        break;
      default:
        ret = undefined;
        break;
    }
    return ret;
  }
}
